export default __webpack_public_path__ + "static/media/img-NBS-bannert.88e8a2db.png";